









import { defineComponent } from '@vue/composition-api'
import Technologies from './components/Technologies.vue'

export default defineComponent({
  name: 'ContactCard',
  components: {
    Technologies,
  },
  setup() {
    const email = 'contact@lachmann.dev'

    return { email }
  },
})
